<template>
  <div class="component-wrapper">
    <div class="flex">
      <h3 
        class="onboarding-display-text newfont" 
        v-for="(t, i) in texts" 
        :key="i">{{ t }}</h3>  
    </div>

    <div class="nav-flex">
      <button 
        v-if="showBack" 
        class="button-std newfont" 
        @click="backstep">
        <span class="material-icons">chevron_left</span>Back
      </button>
      <button 
        v-if="showNext" 
        @click="nextstep" 
        class="button-std newfont"
        :style="nextBtn.styles"
      >Next<span class="material-icons">chevron_right</span>
      </button>
      <button v-if="showExit" 
        @click="Exit" 
        class="">Exit</button>
    </div>
  </div>
</template>

<script>

export default {
  name:"TimeoutDisplay",
  components:{

  },
  props:{
    for: {
      type:String
    },
    event_order:{
      type:Number
    },
    currentFrame:{
      type:Number
    },
    goto: {
      type:Number
    },
    showNext: {
      type: Boolean,
      default: false
    },
    showBack: {
      type: Boolean,
      default: false
    },
    showExit: {
      type: Boolean,
      default: false
    },
    exit:{
      type: Boolean,
      default: false
    },
    backto: {
      type:Number
    },
    texts: {
      type:Array,
      default: function(){
        return []
      }
    },
    nextBtn:{
      type:Object,
      default:function(){
        return {
          styles:{
          }
        }
      }
    },
    timeout: {
      type:Number,
      default:3000
    }
  },
  data(){
    return {
      value:"",
      results:[],
      nextRequestId:1,
      displayedRequestId:0,
      allCheckPass: true,
      errors: [],
      showConfirmPrompt: false,
      confirmMessage:""
    }
  },
  computed:{
    eventpayload: function(){
      return {
        for:this.for, 
        stepVal:this.goto, 
        val:this.value
      }
    }
  },
  watch: {
    currentFrame:function(){
      if(this.currentFrame === this.event_order){
        setTimeout(() => {
          this.nextstep();
          if(this.exit === true){
            this.$emit('exit')
          }
        }, this.timeout)
      }
    }
  },
  methods:{
    nextstep(){
      this.$emit('nextstep', this.eventpayload)

    },
    backstep(){
      this.$emit('backstep', {for:this.for, stepVal:this.backto})
    },
    confirmNull(){
      this.showConfirmPrompt = true;
    }
  },
  beforeCreate(){
          // console.log('nothing gets created before me')
  },
  created(){

  },
  beforeMount(){

  },
  mounted(){

  },
  beforeUpdate(){

  },
  updated(){

  },
  beforeDestroy(){

  },
  destroyed(){

  }
}

</script>

<style scoped>
.onboarding-display-text {
  font-family: 'Noto Sans', sans-serif;
  font-size: 2em;
  font-weight: 700;
}

.flex {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: center;
    align-items:center;
}
.box {
    box-sizing: border-box;
    cursor: pointer;
}
.newfont {
  font-family:'Varela Round';
}
</style>
